import * as Yup from 'yup';
import { AdminAllowanceNames } from '@pharmaplan/common';
import strings from '../../../localization';
import { commonAllowanceValidations, hourlyRateValidator } from '../../../helpers/commonValidators';

export const SelfExpressBookingValidator = () =>
  Yup.object().shape({
    ...commonAllowanceValidations,
    pharmacyId: Yup.string().required(strings.requiredField).nullable(),
    pharmacistId: Yup.string().required(strings.requiredField).nullable(),
    [AdminAllowanceNames.pharmacistHourlyRate]: hourlyRateValidator(),
    startTime: Yup.string().required(strings.requiredField),
    endTime: Yup.string().required(strings.requiredField),
    selectedDate: Yup.string().required(strings.requiredField),
  });

const Validator = () =>
  Yup.object().shape({
    ...commonAllowanceValidations,
    pharmacyId: Yup.string().required(strings.requiredField).nullable(),
    pharmacistId: Yup.string().required(strings.requiredField).nullable(),
    [AdminAllowanceNames.pharmacistHourlyRate]: hourlyRateValidator(),
    [AdminAllowanceNames.pharmacyHourlyRate]: hourlyRateValidator(),
    startTime: Yup.string().required(strings.requiredField),
    endTime: Yup.string().required(strings.requiredField),
    selectedDate: Yup.string().required(strings.requiredField),
  });

export default Validator;
